/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField } from '@molecules';
import { Button } from '@atoms';

import Form from '../Form';

import { FORM_SINGLE_FIELD_EDITED } from './constants';
import RichTextField from '@components/molecules/RichTextField';

// Rich Text Editor is not working as excepted when multiple fields with the
// same name are set. In order to avoid this, here is a parsing solution
const parseToEditable = ({ question, response }) => ({
  questionEdited: question,
  responseEdited: response,
});

const parseToClassic = ({ questionEdited, responseEdited }) => ({
  question: questionEdited,
  response: responseEdited,
});

const FAQFormEdit = ({ onSubmit, buttons, initialValues: initData }) => {
  const [form] = Form.useForm(FORM_SINGLE_FIELD_EDITED);

  const initialValues = React.useMemo(() => form.deserialize(parseToEditable(initData)), [form, initData]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(parseToClassic(value), initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  return (
    <Form
      form={form}
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      layout="vertical"
      labelAlign="left"
      colon={false}
    >
      {buttons && <h2>Edit question</h2>}
      <TextField {...FORM_SINGLE_FIELD_EDITED.QUESTION} />
      <RichTextField {...FORM_SINGLE_FIELD_EDITED.RESPONSE} />
      {buttons ? (
        buttons({ onSubmit: form.submit })
      ) : (
        <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
          ADD QUESTION
        </Button>
      )}
    </Form>
  );
};

export default FAQFormEdit;
